import React, { useState } from "react";
import { SimpleTable } from "../../ui/SimpleTable/SimpleTable";
import { ConfirmDialog } from "../../ConfirmDialog/ConfirmDialog";
import { useFetchAllLoadTypes } from "../../../../../hooks/guide/useFetchAllLoadTypes";
import { LoadTypes } from "../../../../../types/api/guide/loadType.types";
import { loadTypeService } from "../../../../../services/guide/loadType-service";
import { LoadTypeAddModal } from "../../ui/EntityModal/LoadTypeAddModal";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";

interface LoadTypesTableProps {
    title: string;
}

export const LoadTypesTable = ({ title }: LoadTypesTableProps) => {
    const { data: loadTypes, refetch } = useFetchAllLoadTypes();
    const { showSuccess, showError, SnackbarComponent } = useAppSnackbar();
    const [toDelete, setToDelete] = useState<LoadTypes | null>(null);
    const [openModal, setOpenModal] = useState<{ isOpen: boolean; id: string }>({
        isOpen: false,
        id: "",
    });

    const handleDelete = async (id: string) => {
        try {
            await loadTypeService.delete(id);
            showSuccess("Успешное удаление")
            refetch();
        } catch (e) {
            showError(e.response.data);
        }
    };

    return (
        <>
            <SimpleTable<LoadTypes>
                title={title}
                columns={[{ key: "name", title: "Название" }]}
                data={loadTypes}
                enableSearchByName
                getRowKey={(r) => r.id}
                getRowActions={(row) => ({
                    onEdit: () => setOpenModal({ isOpen: true, id: row.id }),
                    onDelete: () => setToDelete(row),
                })}
                emptyText="Справочник пуст"
                setOpen={() => setOpenModal({ isOpen: true, id: "" })}
            />

            <ConfirmDialog
                open={!!toDelete}
                title="Удалить тип загрузки?"
                description={toDelete ? `Будет удалён: ${toDelete.name}` : undefined}
                onCancel={() => setToDelete(null)}
                onConfirm={() => {
                    if (!toDelete) return;
                    handleDelete(toDelete.id);
                    setToDelete(null);
                }}
            />

            {openModal.isOpen && (
                <LoadTypeAddModal
                    id={openModal.id}
                    onClose={() => setOpenModal({ isOpen: false, id: "" })}
                    refetchData={refetch}
                />
            )}
            <SnackbarComponent/>
        </>
    );
};
